import { motion } from "framer-motion";

// Simple fade-up reveal on scroll
export const Reveal = ({ children, delay = 0, className = "", ...props }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    {...props}
  >
    {children}
  </motion.div>
);

// Masked line-by-line reveal for large headings.
// Pass an array of strings (lines).
export const MaskedLines = ({ lines, className = "", delayBase = 0, active = true }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="mask-line">
        <motion.span
          className="block"
          initial={{ y: "110%" }}
          animate={active ? { y: "0%" } : {}}
          transition={{
            duration: 0.9,
            delay: delayBase + i * 0.12,
            ease: [0.22, 1, 0.36, 1],
          }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);
